import { render, staticRenderFns } from "./HomeCategory.vue?vue&type=template&id=483447c8"
import script from "./HomeCategory.vue?vue&type=script&lang=js"
export * from "./HomeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports